var appurl = "oephelper:/";

export default function startApp(command) {
  const md5Command = Buffer.from(command).toString("base64");
  window.location = `${appurl}/${md5Command}/`;
}
